function PatternMascot() {

}


PatternMascot.core = {
    addMascot: function(mascot) {
        var _currentPart = ub.current_part;
        var _modifier = ub.funcs.getModifierByIndex(ub.current_part);
        var _names = ub.funcs.ui.getAllNames(_modifier.name);
        var titleNameFirstMaterial = _names[0].toTitleCase();

        _.each(_names, function (name) {
            var _settingsObject = ub.funcs.getMaterialOptionSettingsObject(name.toTitleCase());
            if (typeof _settingsObject !== "undefined") {
                var _materialOptions = ub.funcs.getMaterialOptions(name.toTitleCase());
                var materialOption = _materialOptions[0];
                var outputPatternObject = PatternMascot.utilities.patternObjectForMaterialOption(mascot, materialOption);

                _settingsObject.mascot_pattern = mascot;

                if (typeof _settingsObject.mascot_pattern_settings === "undefined") {
                    _settingsObject.mascot_pattern_settings = {
                        layout: "brickrow",
                        rotation: 0,
                        scale: {
                            x: .2,
                            y: .2
                        },
                        position: {
                            x: 0,
                            y: 0
                        },
                        opacity: 1
                    };
                }
                
                // Save Settings
                _settingsObject.pattern = outputPatternObject;
                e = _settingsObject;

                PatternMascot.utilities.renderForMaterialOption(e.code, e.pattern.mascot, e.pattern.opacity, e.pattern.position, e.pattern.rotation, e.pattern.scale, e);
            }
        });

        ub.funcs.activatePatterns();
    },

    addMascotPatternInApplication: function(applicationObject, x1, x2, y1, y2, total) {
        PatternMascot.core.applyMascotInApplication(applicationObject, x1, x2, y1, y2, total);

        var matching = ub.data.matchingIDs.getMatchingID(applicationObject.code);

        if (typeof matching !== "undefined") {
            var _matchingSettingsObject = _.find(ub.current_material.settings.applications, {code: matching.toString()});
            _matchingSettingsObject.mascot_pattern = applicationObject.mascot_pattern;

            PatternMascot.core.applyMascotInApplication(_matchingSettingsObject, x1, x2, y1, y2, total);
        }
    },

    applyMascotInApplication: function(applicationObject, x1, x2, y1, y2, total) {
        var utilities = PatternMascot.utilities;
        var _code = applicationObject.code;
        var _uniform_type = ub.current_material.material.type;
        var app_containers = ub.current_material.containers[_uniform_type].application_containers;

        var _primaryView = ub.funcs.getPrimaryView(applicationObject.application);
        var _spriteCollection = ub.objects[_primaryView + '_view']['objects_' + applicationObject.code];
        var _patternObj = utilities.patternObjectForApplication(applicationObject.mascot_pattern);

        applicationObject.pattern_obj = _patternObj;
        applicationObject.withMascotPattern = true;
        applicationObject.withPattern = false;

        if (typeof applicationObject.pattern_obj === 'object') {
            if (typeof applicationObject.mascot_pattern_settings === "undefined") {
                applicationObject.mascot_pattern_settings = {
                    layout: "brickrow",
                    rotation: 0,
                    scale: {
                        x: .13,
                        y: .13
                    },
                    position: {
                        x: 0,
                        y: 0
                    },
                    opacity: 1
                };
            }

            // var default_configuration = PatternMascot.configuration.getConfiguration(null);
            var default_configuration = {
                config: {
                    x1: x1,
                    x2: x2,
                    y1: y1,
                    y2: y2,
                    total: total
                }
            }

            utilities.renderPatternForApplication(applicationObject.application, applicationObject.application.id, _patternObj, _spriteCollection, default_configuration);
        }
    },

    updateMascotSize: function(applicationSettings, value) {
        _.map(applicationSettings.application.views, function(view) {
            var _patternObject = ub.objects[view.perspective + '_view']["pattern_" + applicationSettings.code];
            if (typeof _patternObject !== "undefined") {
                if (_.isObject(_patternObject.children)) {
                    _.map(_patternObject.children, function(child) {
                        child.scale = {
                            x: value,
                            y: value
                        }
                    });

                    applicationSettings.mascot_pattern_settings.scale = {
                        x: value,
                        y: value
                    }
                }
            }
        });
    },

    updateOpacity: function(applicationSettings, value) {
        _.map(applicationSettings.application.views, function(view) {
            var _patternObject = ub.objects[view.perspective + '_view']["pattern_" + applicationSettings.code];
            if (typeof _patternObject !== "undefined") {
                _patternObject.alpha = value;
                applicationSettings.mascot_pattern_settings.opacity = value
            }
        });
    },

    updatePosition: function(applicationSettings, value) {
        _.map(applicationSettings.application.views, function(view) {
            var _patternObject = ub.objects[view.perspective + '_view']["pattern_" + applicationSettings.code];
            if (typeof _patternObject !== "undefined") {
                var _positionY = (0 + parseInt(value));
                _patternObject.position.y = (0 + parseInt(value));
                applicationSettings.mascot_pattern_settings.position = {x: 0, y: _positionY};
            }
        });
    },

    changeLayout: function(applicationSettings, layout) {
        if (typeof applicationSettings !== "undefined") {
            if (typeof applicationSettings.mascot_pattern_settings !== "undefined") {
                if (applicationSettings.mascot_pattern_settings.layout !== layout) {
                    applicationSettings.mascot_pattern_settings.layout = layout;
                    PatternMascot.core.addMascotPatternInApplication(applicationSettings, 20, 60, 20, 50, 300);
                } else {
                    return;
                }
            }
        }
    }
}

PatternMascot.utilities = {
    patternObjectForMaterialOption: function(mascot, materialOption) {
        var _rotationAngle = ub.funcs.translateAngle(materialOption.angle);

        if (materialOption.pattern_id === null) {
            return undefined;
        }

        var _materialOption = materialOption;
       
        var _patternObject  = {
            scale: 0,
            rotation: ub.funcs.translateAngle(_materialOption.angle),
            opacity: 0,
            position: {x: 0 + ub.offset.x, y: 0 + ub.offset.y},
            mascot: {
                name: mascot.name,
                filename: mascot.png_filename,
                scale: 0,
                rotation: 0,
                opacity: 0,
                container_position: {
                    x: 248 + ub.offset.x * 0.9,
                    y: 308 + ub.offset.y * 3.3,
                },
                position: {
                    x: 0 + ub.offset.x,
                    y: 0 + ub.offset.y
                }
            }    
        };

        return _patternObject;
    },

    patternObjectForApplication: function(mascot) {
        var _patternObject  = {
            scale: 0,
            opacity: 0,
            position: {x: 0 + ub.offset.x, y: 0 + ub.offset.y},
            mascot: {
                name: typeof mascot.name === "undefined" ? "Mascot Pattern" : mascot.name,
                filename: mascot.png_filename,
                scale: 0,
                rotation: 0,
                opacity: 0,
                container_position: {
                    x: 248 + ub.offset.x * 0.9,
                    y: 308 + ub.offset.y * 3.3,
                },
                position: {
                    x: 0 + ub.offset.x,
                    y: 0 + ub.offset.y
                }
            }    
        };

        return _patternObject;
    },

    renderForMaterialOption: function(target, patternObject, opacity, position, rotation, scale, settings) {
        var uniform_type = ub.current_material.material.type;
        var target_name = target.toTitleCase();
            target_name = util.toTitleCase(target_name);
        
        var pattern_settings = '';
        var views = ub.data.views;
        var _rotationAngle = 0;
        var _extra = {};
        var _positiion = position;

        pattern_settings = ub.current_material.containers[uniform_type][target_name];
        pattern_settings.containers = {};

        var mascot_pattern_settings = settings.mascot_pattern_settings;

        _.each(views, function (v) {
            var _adjustment = {x: 0, y: 0};
                _adjustment = ub.funcs.coordinateAdjustments(target_name, patternObject, v);
            
            _extra = ub.getAngleofPattern(v, target_name);

            if (typeof _extra !== 'undefined') {
                _rotationAngle = _extra.angle;    
            } else {
                _rotationAngle = 0;
            }

            pattern_settings.containers[v] = {};
            
            // Namespace
            var namespace = pattern_settings.containers[v];
                namespace.container = new PIXI.Container();
            
            // Sprites
            var container = namespace.container;
                container.sprites = {};

            if (mascot_pattern_settings.layout === "brickrow") {
                // Brick Wall Layout
                var loopindex = 0;
                PatternMascot.utilities.brickWall(20, 10, 70, 120, function(x, y) {
                    const mascot = ub.pixi.new_sprite(patternObject.filename);
                    mascot.anchor.set(0.5);

                    loopindex += 1; 

                    mascot.x = x;
                    mascot.y = y;

                    mascot.scale = {
                        x: mascot_pattern_settings.scale.x,
                        y: mascot_pattern_settings.scale.y
                    }

                    mascot.zIndex = loopindex * -1;
                    container.addChild(mascot);
                });
            } else if (mascot_pattern_settings.layout === 'grid') {
                // Grid Layout
                var x1 = 10;
                var x2 = 150;
                var y1 = 10
                var y2 = 100;
                var total = 150;

                for (let i = 0; i < total; i++) {
                    const mascot = ub.pixi.new_sprite(patternObject.filename);
                    mascot.anchor.set(0.5);
                    mascot.x = (i % x1) * x2;
                    mascot.y = Math.floor(i / y1) * y2;
                    mascot.scale = {
                        x: mascot_pattern_settings.scale.x,
                        y: mascot_pattern_settings.scale.y
                    }
                    container.addChild(mascot);
                }
            }

            ub.updateLayersOrder(container);

            var view = v + '_view';
            var mask = ub.objects[view][target + "_mask"];

            if (typeof mask === 'undefined') {
                return;
            }

            container.alpha = mascot_pattern_settings.opacity;
            container.mask = mask;
            container.name = 'patternMascot_' + target;

            if (typeof ub.objects[view]['patternMascot_' + target] === 'object') {
                ub[view].removeChild(ub.objects[view]['patternMascot_' + target]);
            }

            ub.objects[view]['patternMascot_' + target] = container;
            var _p = ub.objects[view]['patternMascot_' + target];

            ub[view].addChild(container);
            container.zIndex = mask.zIndex + (-1);

            _p.position.x += -100;
            _p.position.y += -350;


            if (mascot_pattern_settings.position.x === 0 && mascot_pattern_settings.position.y === 0) {
                mascot_pattern_settings.position = _p.position;
            } else {
                _p.position = mascot_pattern_settings.position;
            }

            var _soPattern = ub.funcs.getMaterialOptionSettingsObject(target_name).pattern

            if (_soPattern.dirty) {
                _p.position = position;
            }
            
            _p.anchor = {x: 0.5, y: 0.5};
            _p.pivot = {x: 0.5, y: 0.5};

            ub.updateLayersOrder(ub[view]);
        });
    },

    renderPatternForApplication: function(application, target, patternObject, sprite_collection, settings) {
        var self = this;
        var _container = undefined;
        var _textSprite = undefined;
        var _maskSprite = undefined; 
        var _sprites = undefined;
        var _primaryView = undefined;
        var _applicationSettings = undefined;
        var _colorObj = undefined;
        var _teamColor = undefined;
        var _primaryViewStr = '';
        var _patternIDStr = '';        
        var _applicationViewObjects = undefined;

        _applicationSettings = ub.current_material.settings.applications[application.id];
        _applicationViewObjects = ub.funcs.getApplicationViewObjects(application.id);

        var patternSettings = _applicationSettings.mascot_pattern_settings;

        _.each(_applicationViewObjects, function (viewObject) {
            _primaryView = viewObject.perspective;
            _primaryViewStr = _primaryView + '_view';
            _patternIDStr = 'pattern_' + application.id;
            _sprites = ub.objects[_primaryViewStr]['objects_' + application.id];
            _textSprite = _.find(_sprites.children, {ubName: 'Base Color'});
            _maskSprite = _.find(_sprites.children, {ubName: 'Mask'});
            _maskSprite.alpha = 1;

            self.removePatternFromApplicationViewObject(application.id, _primaryView);

            ub.current_material.containers[application.id] = {};
            ub.objects[_primaryViewStr][_patternIDStr] = {};

            _container = new PIXI.Container();
            _container.sprites = {};

            var configuration = settings.config;

            if (patternSettings.layout === "brickrow") {
                // Brick Wall Layout
                var loopindex = 0;
                var offsetY = 50;
                var offsetX = 85;
                var rows = 20;
                var cols = 10;
                if (_applicationSettings.application_type === "team_name" || _applicationSettings.application_type === "player_name") {
                    offsetY = 45;
                    offsetX = 75;
                    cols = 20;
                    rows = 20;
                }

                PatternMascot.utilities.brickWall(rows, cols, offsetY, offsetX, function(x, y) {
                    const mascot = ub.pixi.new_sprite(patternObject.mascot.filename);
                    mascot.anchor.set(0.5);

                    loopindex += 1; 

                    mascot.x = x;
                    mascot.y = y;

                    mascot.scale = {
                        x: patternSettings.scale.x,
                        y: patternSettings.scale.y
                    }

                    mascot.zIndex = loopindex * -1;
                    _container.addChild(mascot);
                });
            } else if (patternSettings.layout === "grid") {
                // Grid Layout
                for (let i = 0; i < configuration.total; i++) {
                    const mascot = ub.pixi.new_sprite(patternObject.mascot.filename);
                    mascot.anchor.set(0.5);
                    mascot.x = (i % configuration.x1) * configuration.x2;
                    mascot.y = Math.floor(i / configuration.y1) * configuration.y2;
                    mascot.scale = {
                        x: patternSettings.scale.x,
                        y: patternSettings.scale.y
                    }
                    mascot.zIndex = i * -1;
                    _container.addChild(mascot);
                }
            } else {
                console.log("Cannot find pattern layout");
            }

            _container.alpha = patternSettings.opacity;
            _container.scale = new PIXI.Point(1, 1);
            _container.mask = _maskSprite;
            _container.zIndex = -12;

            if (typeof _textSprite.pattern_layer === "object" ){
                _textSprite.pattern_layer.removeChildren();
                _textSprite.removeChild(_textSprite.pattern_layer);
            }

            _textSprite.pattern_layer = _container;
            _textSprite.addChild(_textSprite.pattern_layer);

            ub.updateLayersOrder(_textSprite);

            var mascotPatternPosition = -400

            if (patternSettings.position.y !== 0) {
                mascotPatternPosition = patternSettings.position.y
            }

            _container.position.x = -400;
            _container.position.y = mascotPatternPosition;

            patternSettings.position = _container.position;

            _applicationSettings.pattern_obj = patternObject;
            ub.objects[_primaryViewStr][_patternIDStr] = _container;
        });
    },

    removePatternFromApplicationViewObject(applicationID, perspective) {
        var _perpectiveStr = perspective + '_view';
        var _patternStr = 'pattern_' + applicationID;

        if (typeof ub.objects[_perpectiveStr][_patternStr] === "object") {

            ub.objects[_perpectiveStr][_patternStr]
            ub[_perpectiveStr].removeChild(_patternStr);
        }
        return;
    },

    hasMascot: function(code) {
        var applicationSettings = ub.funcs.getApplicationSettings(code);

        if (typeof applicationSettings !== "undefined") {
            return typeof applicationSettings.mascot_pattern !== "undefined";
        }

        return false;
    },

    brickWall: function(rows, cols, offsetY, offsetX, callback) {
        var self = this;
        for (var r = rows; r > -1; r--) {
            var y = r * offsetY;
            
            for(var c = 0; c < cols; c++) {
                var x = (c * offsetX) + self.getRandom(2, 8);
                x = (r % 2 == 0) ? x : x + (offsetX / 2);

                callback(x, y);
            }
        }
    },

    getRandom: function (min, max) {
        return min + Math.random() * (max - min);
    }
}

PatternMascot.configuration = {
    configs: [
        {
            code: "straight",
            config: {
                x1: 20,
                x2: 60,
                y1: 20,
                y2: 50,
                total: 300
            }
        }
    ],

    getConfiguration: function(code) {
        var config = _.find(this.configs, {code: code});

        if (typeof config === "undefined") {
            config = _.first(this.configs);
            ub.utilities.warn("Cannot find configuration with the code of " + code + ". Using default configuration.");
        }

        return config;
    }
}